// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "li[data-v-6371c51b]{list-style:none}.role-name[data-v-6371c51b]{font-size:16px;font-weight:700}.role-summary[data-v-6371c51b]{font-size:14px}.no-permissions[data-v-6371c51b]{color:gray;font-style:italic}.expansion-panel[data-v-6371c51b]{border-bottom:1px solid #e0e0e0;border-radius:4px;margin-bottom:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
